import { render } from "./Anchor.vue?vue&type=template&id=04b75f3a&scoped=true&ts=true"
import script from "./Anchor.vue?vue&type=script&setup=true&lang=ts"
export * from "./Anchor.vue?vue&type=script&setup=true&lang=ts"

import "./Anchor.vue?vue&type=style&index=0&id=04b75f3a&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b75f3a"],['__file',"src/components/player/Anchor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04b75f3a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04b75f3a', __exports__)) {
    console.log('reload')
    api.reload('04b75f3a', __exports__)
  }
  
  module.hot.accept("./Anchor.vue?vue&type=template&id=04b75f3a&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('04b75f3a', render)
  })

}


export default __exports__